import React from 'react';

const SquarePost = ( { post } ) => {
	return (<div>
			<article id={ 'post-' + post.id }>
				<div id={ 'heading-' + post.id }
				     data-toggle="collapse"
				     data-target={ '#collapse-' + post.id }>
					<header className="entry-header">
						<div className="post-meta">
							<div>
								<h5 className="category">
									<a href={ post.category_link }>{ post.category_name }</a>
								</h5>
								<span className="date">{ post.time }</span>
							</div>
							<a href={ post.category_link }>
								<div className="category-icon-box">
                                    <span
	                                    className="sr-only">{ post.category_name }
                                    </span>
									<span
										className={ 'category-icon ' + post.category_icon_class }
										aria-hidden="true">
                                    </span>
								</div>
							</a>
						</div>

						<h3 className="post-title">
							<a href={ post.permalink }>
								{ post.display_title
								  ? post.display_title
								  : post.title }
							</a>
						</h3>
					</header>
				</div>
				<div className="entry-meta">
					<div className="read-time">
						<svg width="16" height="17" viewBox="0 0 16 17"
						     fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_1480_577)">
								<path
									d="M8 16.5C3.58867 16.5 0 12.9113 0 8.5C0 4.08867 3.58867 0.5 8 0.5C12.4113 0.5 16 4.08867 16 8.5C16 12.9113 12.4113 16.5 8 16.5ZM8 1.83333C4.324 1.83333 1.33333 4.824 1.33333 8.5C1.33333 12.176 4.324 15.1667 8 15.1667C11.676 15.1667 14.6667 12.176 14.6667 8.5C14.6667 4.824 11.676 1.83333 8 1.83333ZM11.3333 8.5C11.3333 8.13133 11.0353 7.83333 10.6667 7.83333H8.66667V4.5C8.66667 4.13133 8.368 3.83333 8 3.83333C7.632 3.83333 7.33333 4.13133 7.33333 4.5V8.5C7.33333 8.86867 7.632 9.16667 8 9.16667H10.6667C11.0353 9.16667 11.3333 8.86867 11.3333 8.5Z"
									fill="#323232"/>
							</g>
							<defs>
								<clipPath id="clip0_1480_577">
									<rect width="16" height="16" fill="white"
									      transform="translate(0 0.5)"/>
								</clipPath>
							</defs>
						</svg>
						<div
							dangerouslySetInnerHTML={ { __html: post.read_time } }/>
						min.read
					</div>
					<div className="bookmark">
						<i className={ 'fa-bookmark ' + (ISDA_Main.userBookmarks.includes( post.id )
						                                 ? 'fa'
						                                 : 'fa-regular'
						) + ' toggle-bookmark' } data-post-id={ post.id }></i>
					</div>
				</div>
			</article>
		</div>
	);
};

export default SquarePost;